module.exports = __webpack_public_path__ + "static/media/russia.562474ef.svg";